import type { ThemeConfig } from '../types'
import { trailheadConfig } from './trailhead'
import { emberConfig } from './ember'
import { tidepoolConfig } from './tidepool'
import { canopyConfig } from './canopy'
import { expeditionConfig } from './expedition'
import { stardustConfig } from './stardust'
import { fieldJournalConfig } from './fieldJournal'

export interface ThemePreset {
  id: string
  name: string
  description: string
  config: ThemeConfig
  isDark: boolean
  swatches: [string, string, string]
}

export const themePresets: ThemePreset[] = [
  {
    id: 'trailhead',
    name: 'Trailhead',
    description: 'Home base — warm Scout Green, Honey accents, Cream canvas',
    config: trailheadConfig,
    isDark: false,
    swatches: ['#3D5A3C', '#D4A84B', '#FAF8F3'],
  },
  {
    id: 'ember',
    name: 'Ember',
    description: 'Dark & cozy — Coral firelight glow, warm shadows, spacious',
    config: emberConfig,
    isDark: true,
    swatches: ['#E07B5A', '#D4A84B', '#1C1614'],
  },
  {
    id: 'tidepool',
    name: 'Tidepool',
    description: 'Coastal & clean — Sky blue, pill buttons, no shadows, compact',
    config: tidepoolConfig,
    isDark: false,
    swatches: ['#5B8FA8', '#D4A84B', '#F6F9FB'],
  },
  {
    id: 'canopy',
    name: 'Canopy',
    description: 'Deep forest — rich greens, Violet wildflower accents, immersive',
    config: canopyConfig,
    isDark: false,
    swatches: ['#2D4A2C', '#8B7BC8', '#F4F7F2'],
  },
  {
    id: 'expedition',
    name: 'Expedition',
    description: 'Bold adventure — rugged borders, topo-map texture, uppercase headings',
    config: expeditionConfig,
    isDark: false,
    swatches: ['#8B5E2A', '#E07B5A', '#FBF7F0'],
  },
  {
    id: 'stardust',
    name: 'Stardust',
    description: 'Mystical night — Violet glow, Honey stars, dreamy transitions',
    config: stardustConfig,
    isDark: true,
    swatches: ['#8B7BC8', '#D4A84B', '#14121C'],
  },
  {
    id: 'fieldJournal',
    name: 'Field Journal',
    description: 'Warm & tactile — dashed borders, paper texture, naturalist notebook feel',
    config: fieldJournalConfig,
    isDark: false,
    swatches: ['#5b7c3a', '#b8860b', '#3a3226'],
  },
]

export function getPresetById(id: string): ThemePreset | undefined {
  return themePresets.find(p => p.id === id)
}

export { trailheadConfig } from './trailhead'
export { emberConfig } from './ember'
export { tidepoolConfig } from './tidepool'
export { canopyConfig } from './canopy'
export { expeditionConfig } from './expedition'
export { stardustConfig } from './stardust'
export { fieldJournalConfig } from './fieldJournal'
